<template>
    <section id="play-live" class="layout layout-scale" :class="{ 'opacity-0': !isAlreadyShow }">
        <quiz-header
            ref="quizHeader"
            :title="stripHtmlTag(title)"
            :current-quiz-index="currentQuizIndex"
            :question-count="questionCount"
            :show-progress-bar="currentProgressBarStatus"
        />

        <bg-music-mute-btn
            v-if="playerSound.effectMusic && question.question_type !== 'video' && question.question_type !== 'music'"
            class="pr-4"
            :is-muted="isMuted"
            :is-spotify="isSoundQuestion"
        ></bg-music-mute-btn>

        <div class="content flex items-center animated fadeIn pt-3">
            <div class="mx-auto content-container w-full">
                <div
                    v-if="question.question_type !== 'puzzle'"
                    class="flex pt-0 sm:pt-6 items-center flex-col justify-center"
                >
                    <div
                        v-if="
                            typeof question.image != 'undefined' &&
                            question.image !== null &&
                            question.image !== '' &&
                            question.question_type !== 'hotspot'
                        "
                        :class="{
                            'bg-main-container border-ui-style': true,
                            'has-video': question.question_type === 'video',
                            invisible: hideTitleImage
                        }"
                    >
                        <div
                            v-if="question.question_type !== 'video'"
                            :class="{
                                'bg-main bg-cover bg-image bg-center bg-norepeat border-3 border-white mx-auto': true,
                                'w-48 sm:w-64 h-48 sm:h-64': isAllImageAnswer(question.answers),
                                'w-64 h-64': !isAllImageAnswer(question.answers),
                                'animate-reveal': question.question_type === 'reveal_image'
                            }"
                            :style="{ 'background-image': 'url(' + question.image + ')' }"
                        ></div>
                        <div
                            v-if="question.question_type == 'video'"
                            class="video-box w-full h-64 border-3 border-ui-style"
                        >
                            <video-player
                                ref="videoPlayer"
                                class="w-full h-full"
                                v-if="question.question_type == 'video'"
                                :video-meta="question"
                                :video-path="question.video"
                                :time-duration="question.video_time"
                                :user-question-music="playerSound.questionMusic"
                            >
                            </video-player>
                        </div>
                    </div>

                    <live-quiz-equalizer
                        ref="musicPlayer"
                        v-if="question.question_type == 'music'"
                        @click="toggleMusic"
                        class="mb-2"
                    ></live-quiz-equalizer>

                    <div
                        v-if="question.question_type == 'music'"
                        class="theme-ui-text-color text-white font-size-14 mb-2"
                    >
                        {{ $t('playlive_click_to_play_song') }}
                    </div>
                    <h1
                        id="question-title"
                        class="theme-question-text-color theme-question-shadow font-bold text-white text-center mt-0 pt-2 mb-5 w-full has-text-balanced"
                        :class="{ 'mb-12': question.image === null && question.image === '', hidden: !question.title }"
                    >
                        {{ question.title }}
                    </h1>

                    <!-- Fallback title is empty -->
                    <div v-if="!question.title" class="my-2"></div>
                    <!-- Fallback title is empty -->
                </div>

                <!-- START SELECT -->
                <div v-if="isMultiple" class="text-center">
                    <span
                        class="theme-question-text-color theme-question-shadow text-white font-size-16 inline-block mb-2"
                        >{{ $t('playlive_correct_count', { answersCount: question.answers_count }) }}</span
                    >
                </div>
                <div class="answer-box" :style="[question.question_type == 'hotspot' ? { padding: 0 } : {}]">
                    <ChoiceAnswer
                        v-if="
                            ['basic', 'music', 'reveal_image', 'scale_image', 'video'].indexOf(question.question_type) >
                                -1 || !question.question_type
                        "
                        class="opacity-0 pointer-events-none"
                        :class="{ 'show-answer': isShowAnswer }"
                        :question="question"
                        :isAllImageAnswer="isAllImageAnswer(question.answers)"
                        :selectedChoice="selectedChoice"
                        :isMultiple="isMultiple"
                        style="transition: opacity 1s"
                        @selectAnswer="answerIndex => handleClickSelectAnswer(answerIndex)"
                    />
                    <TypingAnswer
                        v-if="question.question_type == 'typing_question'"
                        class="opacity-0 pointer-events-none"
                        :class="{ 'show-answer': isShowAnswer }"
                        :question="question"
                        style="transition: opacity 1s"
                        @value="submitTyping"
                    />
                    <SortingAnswer
                        v-if="question.question_type == 'sorting_list' && isAlreadyRandom"
                        class="opacity-0 pointer-events-none"
                        :class="{ 'show-answer': isShowAnswer }"
                        :question="question"
                        style="transition: opacity 1s"
                        @value="submitTyping"
                    />
                    <HotspotAnswer
                        v-if="question.question_type == 'hotspot'"
                        ref="hotspot-container"
                        class="opacity-0 pointer-events-none"
                        :class="{ 'show-answer': isShowAnswer }"
                        :question="question"
                        :isMultiple="isMultiple"
                        @selectAnswer="answerIndex => handleClickSelectAnswer(answerIndex)"
                    />
                </div>
                <!-- END SELECT -->

                <!-- PUZZLE -->
                <div
                    v-if="question.question_type === 'puzzle'"
                    class="puzzle-container opacity-0 pointer-events-none"
                    :class="{ 'show-answer': isShowAnswer }"
                    style="transition: opacity 1s"
                    ref="puzzle-container"
                >
                    <div class="puzzle-backdrop">
                        <div class="circle-box">
                            <div class="circle-bg hide"></div>
                            <i id="check-icon" class="fas hide theme-ui-text-color"></i>
                            <i id="x-icon" class="fas fa-times-circle hide theme-ui-text-color"></i>
                        </div>
                    </div>
                </div>
                <!-- END PUZZLE -->

                <!-- SCRAMBLE -->
                <div v-if="question.question_type == 'scramble'">
                    <template
                        v-if="typeof question.custom_message !== 'undefined' && question.custom_message.length > 0"
                    >
                        <div
                            class="theme-question-text-color theme-question-shadow text-white text-center font-size-16 mb-2"
                        >
                            {{ question.custom_message }}
                        </div>
                    </template>
                    <p
                        v-else
                        class="theme-question-text-color theme-question-shadow text-white text-center font-size-16 mb-2"
                    >
                        <i class="theme-question-shadow fas fa-arrows-alt"></i>
                        {{ $t('sorting_dragdrop_correct_answer') }}
                    </p>
                    <Scramble
                        v-if="question.question_type == 'scramble'"
                        class="opacity-0 pointer-events-none"
                        :class="{ 'show-answer': isShowAnswer }"
                        :question="question"
                        style="transition: opacity 1s"
                        @value="submitTyping"
                    />
                </div>
                <!-- END SCRAMBLE -->
            </div>
        </div>
        <div class="footer"></div>

        <socket-reconnect-modal
            v-if="showPlayerPopup"
            @ok="onPlayerClickOk"
            :icon="playerPopupIcon"
            :show-footer="true"
            :retry-fail-message="playerRetryFailMessage"
            :ok-button="playerOkButton"
            :title="playerPopupTitle"
            :message="playerPopupMessage"
        />
    </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import popup from '@/lib/popup.js'
import ResizeScale from '@/lib/resize-scale.js'
import gsap from 'gsap'
import helper from '@/lib/helper.js'
import preloadSongMixin from '@/mixins/preload-song'
import { isLoggedIn } from '@/lib/user.js'
import ChoiceAnswer from '@/components/ChoiceAnswer.vue'
import TypingAnswer from '@/components/TypingAnswer.vue'
import Scramble from '@/components/Scramble.vue'
import SortingAnswer from '@/components/SortingAnswer.vue'
import Puzzle from '@/lib/puzzle.js'
import QuizHeader from '@/components/QuizHeader.vue'
import VideoPlayer from '@/components/VideoPlayer.vue'
import LiveQuizEqualizer from '@/components/LiveQuizEqualizer.vue'
import BgMusicMuteBtn from '@/components/BgMusicMuteBtn.vue'
import SocketReconnectModal from '@/components/SocketReconnectModal.vue'
import helperMixins from '@/mixins/helper.js'
import balanceText from '@/mixins/balance-text.js'
import setBackgroundQuestion from '@/mixins/set-bg-question.js'
import socketConnectionMixin from '@/mixins/socket-connection.js'
import appConfig from '@/app.config.js'
import HotspotAnswer from '@/components/HotspotAnswer.vue'
import { playerSocketSetting } from '@/mixins/live-quiz-socket.js'

export default {
    components: {
        ChoiceAnswer,
        TypingAnswer,
        Scramble,
        SortingAnswer,
        QuizHeader,
        VideoPlayer,
        LiveQuizEqualizer,
        BgMusicMuteBtn,
        SocketReconnectModal,
        HotspotAnswer
    },

    mixins: [preloadSongMixin, helperMixins, socketConnectionMixin, balanceText, setBackgroundQuestion],

    sockets: {
        no_user_in_room: function () {
            this.stopSong()
        },

        master_pressed_next: function (data) {
            const currentIndex = this.currentQuizIndex
            this.isMasterPressedNext = true

            clearTimeout(this.quizTimeOut)

            popup.alert(
                this.$t('playlive_alert_timeup'),
                function () {
                    this.$socket.emit('user_answered', {
                        room: this.code,
                        type: this.type,
                        name: this.name,
                        questionIndex: currentIndex,
                        answerIndex: -1,
                        timer: this.getTimer()
                    })

                    this.$store.commit('player/updateCurrentQuizIndex', data.index)

                    this.$router.push({
                        name: 'redirect-quiz',
                        params: {
                            code: this.$route.params.code
                        }
                    })
                }.bind(this)
            )
        },

        master_pressed_end: function () {
            let txtType =
                this.type === 'poll'
                    ? this.firstUppercase(this.$t('playlive_share_type_poll'))
                    : this.firstUppercase(this.$t('playlive_share_type_quiz'))

            popup.alert(
                this.$t('playlive_alert_done', { type: txtType }),
                function () {
                    this.$router.replace({
                        name: 'summary'
                    })
                }.bind(this)
            )
        },

        master_ended_game: function () {},

        continue_game_joined: function (data) {
            const currentIndex = this.currentQuizIndex
            let txtDone =
                this.type === 'poll'
                    ? this.firstUppercase(this.$t('playlive_share_type_poll'))
                    : this.firstUppercase(this.$t('playlive_share_type_quiz'))
            let txtCancelled =
                this.type === 'poll' ? this.$t('playlive_share_type_poll') : this.$t('playlive_share_type_quiz')

            if (currentIndex !== data.index && data.index > -1 && data.index != null) {
                this.isMasterPressedNext = true

                popup.alert(
                    this.$t('playlive_alert_timeup'),
                    function () {
                        this.$store.commit('player/updateCurrentQuizIndex', data.index)

                        this.$router.push({
                            name: 'redirect-quiz',
                            params: {
                                code: this.$route.params.code
                            }
                        })
                    }.bind(this)
                )
            }

            if (data.index === -1) {
                this.isEndEnable = false
                this.isNextEnable = true

                popup.alert(
                    this.$t('playlive_alert_done', { type: txtDone }),
                    function () {
                        this.$router.replace({
                            name: 'summary'
                        })
                    }.bind(this)
                )
            }

            if (data.index == null) {
                popup.alert(this.$t('playlive_alert_cancelled', { type: txtCancelled }), function () {
                    window.location.href = '/join'
                })
            }
        },

        user_receive_ping: function (data) {
            this.lastMasterPingAt = new Date()
            this.$socket.emit('user_ping_back_to_master', {
                room: data.room,
                name: this.name
            })
        },

        ...playerSocketSetting
    },

    data: function () {
        return {
            selectedChoice: [],
            startTimer: new Date().getTime(),
            isSelected: false,
            isMasterPressedNext: false,
            isAlreadyShow: false,
            quizTimeOut: null,
            quizTimerInterval: null,
            currentTimeoutSecond: 0,
            isSoundQuestion: false,
            isPlayingMusic: false,
            songXhrRequest: null,
            puzzleSize: null,
            isAlreadyRandom: false,
            componentsAlreadyCount: 0,
            isShowAnswer: false,
            millesecAnswer: 0,
            millisecQuestion: 0,
            correctIconList: [
                {
                    icon: 'fa-check-circle',
                    bg: true
                },
                {
                    icon: 'fa-laugh-wink',
                    bg: true
                },
                {
                    icon: 'fa-grin-stars',
                    bg: true
                },
                {
                    icon: 'fa-star',
                    bg: false
                },
                {
                    icon: 'fa-heart',
                    bg: false
                },
                {
                    icon: 'fa-thumbs-up',
                    bg: false
                }
            ],

            currentProgressBarStatus: false,

            showActiveSoundModal: false
        }
    },

    watch: {
        playerSound: {
            handler(data) {
                if (this.question.spotify_track) {
                    // Show player
                    if (data.questionMusic && this.$refs.musicPlayer) {
                        this.$refs.musicPlayer.showPlayer()
                        this.isPlayingMusic = true
                    }

                    // Hide player
                    if (!data.questionMusic && this.$refs.musicPlayer) {
                        this.$refs.musicPlayer.hidePlayer()
                        this.isPlayingMusic = false
                    }

                    if (!data.questionMusic || !this.isPlayingMusic) {
                        this.handleMute(this.audioSpotify, true)
                    } else {
                        this.handleMute(this.audioSpotify, false)
                        this.audioSpotify.muted = false
                    }
                } else if (this.question.question_type == 'video') {
                    if (!data.questionMusic) {
                        this.$refs.videoPlayer.setMuted(true)
                    } else {
                        this.$refs.videoPlayer.setMuted(false)
                    }
                }
            },
            deep: true
        }
    },

    mounted: function () {
        //from mixins set bg question//
        this.removeBackdrop()
        this.removeVideoBackdrop()

        if (this.isSupportBasicFullscreen(this.question)) {
            this.setTitleImageToBackground(this.question)
        }

        if (this.isSupportVideoFullscreen(this.question)) {
            this.setTitleImageToBackground(this.question)
            this.setVideoToBackground(this.question)
        }

        const contentElem = document.getElementsByClassName('content-container')[0]
        if (this.question.answers.length == 4 && this.isAllImageAnswer(this.question.answers)) {
            contentElem.classList.add('count-box-size')
        } else {
            contentElem.classList.remove('count-box-size')
        }

        this.currentProgressBarStatus = this.progressBarStatus
        this.millisecQuestion = this.delayQuestion * 1000
        this.millesecAnswer = this.delayAnswer * 1000

        this.setShowAnswer()
        this.touchActionNone()
        this.checkMasterActive()

        if (this.question.title) {
            this.useBalanceText('#question-title')
        }
        if (this.currentProgressBarStatus && this.timeLimit) {
            this.$refs.quizHeader.setTotalTime(this.millisecQuestion)
        }

        if (this.question.question_type == 'video' && this.$refs.videoPlayer) {
            this.$nextTick(() => {
                let videoDuration = (this.question.video_time[1] - this.question.video_time[0]) * 1000
                this.millisecQuestion += videoDuration

                if (this.currentProgressBarStatus && this.timeLimit) {
                    this.$refs.quizHeader.setTotalTime(this.millisecQuestion)
                }

                this.$refs.videoPlayer.setPlay()
            })
        }

        window.onbeforeunload = function () {
            return 'Are you sure you want to leave this page? You will loose any unsaved actions'
        }

        // this.$store.commit('updateRemoveAppPaddingX', false)

        window.addEventListener('unload', this.handleUserCloseWindow)

        this.$socket.emit('check_game_index', {
            room: this.code
        })

        this.randomChoices().then(() => {
            setTimeout(() => {
                // this.resizeScaleQuizFrame()
                this.isAlreadyRandom = true

                // Receive custom event componentAlready
                window.addEventListener('componentAlready', () => {
                    let countAlready =
                        this.question.question_type === 'puzzle' || this.question.question_type === 'hotspot' ? 1 : 2

                    if (this.$route.name === 'quiz') {
                        this.componentsAlreadyCount++
                        if (this.componentsAlreadyCount == countAlready) {
                            this.resizeScaleQuizFrame()
                        }
                    }
                })
            }, 100)

            if (this.question.title) {
                helper.quizFontSize('question-title', this.question.title.length)
            }

            this.checkCurrentGame()
            if (this.timeLimit) {
                this.setQuizTimeout()
            }
            this.checkTypeOfQuestion()
            this.setPuzzleImage()
        })
    },

    beforeDestroy() {
        this.$refs.quizHeader.setTotalTime(0)
    },

    destroyed() {
        window.onbeforeunload = function () {}
        clearTimeout(this.quizTimeOut)

        if (this.quizTimerInterval) {
            clearInterval(this.quizTimerInterval)
        }
    },

    methods: {
        handleUserCloseWindow: function () {
            this.$store.dispatch('player/emitUserEndGameToSocket', {
                room: this.code,
                name: this.name,
                socket: this.$socket
            })
        },

        setShowAnswer() {
            setTimeout(() => {
                this.isShowAnswer = true
            }, this.millesecAnswer)
        },

        isAllImageAnswer: function (answers) {
            var hasImages = 0

            answers.forEach(function (answer) {
                if (typeof answer.image != 'undefined' && answer.image !== null && answer.image !== '') {
                    hasImages++
                }
            })

            return hasImages == answers.length
        },

        handleClickSelectAnswer: function (index) {
            if (this.question.question_type == 'video') {
                this.$refs.videoPlayer.stopVideo()
            }

            if (this.isSelected) {
                return false
            }

            if (this.isMultiple) {
                let indexValidation = 0
                let sameIndex = 0

                this.selectedChoice.map((selected, i) => {
                    if (selected === index) {
                        indexValidation++
                        sameIndex = i
                    }
                })

                if (indexValidation > 0) {
                    this.selectedChoice.splice(sameIndex, 1)
                } else {
                    this.selectedChoice.push(index)
                }

                if (this.selectedChoice.length !== this.question.answers_count) {
                    return false
                }
            } else {
                this.selectedChoice = [index]
            }

            if (isLoggedIn() && this.checkIsCorrect()) {
                this.$store.commit('player/addCoin')
            }

            this.isSelected = true

            this.$socket.emit('user_answered', {
                room: this.code,
                type: this.type,
                name: this.name,
                questionIndex: this.currentQuizIndex,
                answerIndex: this.selectedChoice,
                timer: this.getTimer()
            })

            this.$store.dispatch('player/handleNextResult')

            this.$refs.quizHeader.stopProgressBar()

            let timeout

            if (this.question.question_type == 'hotspot') {
                timeout = 500
            }

            setTimeout(() => {
                this.$router.replace({
                    name: 'result',
                    params: {
                        code: this.$route.params.code
                    }
                })
            }, timeout)

            if (!isNaN(this.audioSpotify.duration)) {
                this.audioSpotify.pause()
            }
        },

        submitTyping(value) {
            if (this.isSelected) {
                return false
            }

            if (isLoggedIn() && value.value) {
                this.$store.commit('player/addCoin')
            }

            this.isSelected = true

            var answerResult = {
                room: this.code,
                type: this.type,
                name: this.name,
                questionIndex: this.currentQuizIndex,
                answerIndex: 0,
                timer: this.getTimer(),
                value: value.value
            }

            if (value.typingAnswer != undefined) {
                answerResult['typingAnswer'] = value.typingAnswer
            }

            if (this.question.question_type == 'typing_question') {
                this.$socket.emit('user_typing_answered', answerResult)
            }

            if (this.question.question_type == 'scramble') {
                this.$socket.emit('user_typing_answered', answerResult)
            }

            if (value.sortingList != undefined) {
                answerResult['sortingList'] = value.sortingList
            }

            // sorting_type
            if (this.question.question_type == 'sorting_list') {
                this.$socket.emit('user_sorting_answered', answerResult)
            }

            this.$store.dispatch('player/handleNextResult')

            this.$refs.quizHeader.stopProgressBar()

            this.$router.replace({
                name: 'result',
                params: {
                    code: this.$route.params.code
                }
            })

            if (!isNaN(this.audioSpotify.duration)) {
                this.audioSpotify.pause()
            }
            if (this.question.question_type == 'video') {
                this.$refs.videoPlayer.stopVideo()
            }
        },

        checkIsCorrect() {
            let validation = 0
            let selected = typeof this.selectedChoice !== 'object' ? [this.selectedChoice] : this.selectedChoice

            this.question.answers.forEach(answer => {
                selected.forEach(select => {
                    if (select === answer.initIndex && answer.is_correct) {
                        validation++
                    }
                })
            })

            return (
                (validation === this.question.answers_count && this.isMultiple) || (validation > 0 && !this.isMultiple)
            )
        },

        getTimer: function () {
            var current = new Date().getTime(),
                secondDiff = Math.abs(current - this.startTimer)

            return Math.ceil(secondDiff / 1000)
        },

        randomChoices: function () {
            return new Promise(resolve => {
                this.question.answers = this.question.answers.map((item, index) => {
                    return {
                        ...item,
                        initIndex: index
                    }
                })

                if (this.type !== 'poll') {
                    this.question.answers = this.shuffle(this.question.answers)
                }

                resolve()
            })
        },

        shuffle: function (array) {
            let currentIndex = array.length,
                temporaryValue,
                randomIndex

            while (0 !== currentIndex) {
                randomIndex = Math.floor(Math.random() * currentIndex)
                currentIndex -= 1
                temporaryValue = array[currentIndex]
                array[currentIndex] = array[randomIndex]
                array[randomIndex] = temporaryValue
            }

            return array
        },

        resizeScaleQuizFrame() {
            const contentElem = document.getElementsByClassName('content-container')[0]
            const layoutElem = document.getElementsByClassName('layout')[0]
            const headerElem = document.getElementsByClassName('header')[0]
            const footerElem = document.getElementsByClassName('footer')[0]
            const footerHeight = footerElem.getBoundingClientRect().height
            const headerHeight = headerElem.getBoundingClientRect().height
            const uselessHeight = headerHeight + footerHeight

            layoutElem.style.setProperty('--useless-h', `${uselessHeight}px`)

            new ResizeScale({
                width: contentElem.getBoundingClientRect().width,
                height: contentElem.getBoundingClientRect().height,
                child: contentElem,
                parent: layoutElem,
                uselessHeight: uselessHeight,
                noTransForm: true
            })

            document.getElementById('app').classList.add('overflow-hidden')
            document.getElementById('app').classList.add('relative')

            this.isAlreadyShow = true
        },

        checkCurrentGame: function () {
            this.$socket.emit('check_game_index', {
                room: this.code
            })
        },

        resumeQuizTimeout: function () {
            this.setQuizTimeout(this.currentTimeoutSecond)
        },

        pauseQuizTimeout: function () {
            clearTimeout(this.quizTimeOut)
            clearInterval(this.quizTimerInterval)
        },

        setQuizTimeout: function (millisecQuestion) {
            const milliSec = millisecQuestion || this.millisecQuestion

            this.quizTimeOut = setTimeout(() => {
                let sendAnswerTime = 0

                this.isSelected = true

                this.stopSong()

                if (this.question.question_type == 'puzzle') {
                    this.puzzleResultAnimation(false)
                    sendAnswerTime = appConfig.delayPuzzleDone * 1000
                }

                setTimeout(() => {
                    this.$socket.emit('user_answered', {
                        room: this.code,
                        type: this.type,
                        name: this.name,
                        questionIndex: this.currentQuizIndex,
                        answerIndex: -1,
                        timer: this.getTimer()
                    })

                    this.$store.dispatch('player/handleNextResult')

                    this.$router.replace({
                        name: 'result',
                        params: {
                            code: this.$route.params.code
                        }
                    })
                }, sendAnswerTime)
            }, milliSec)

            this.currentTimeoutSecond = milliSec

            this.quizTimerInterval = setInterval(() => {
                if (this.currentTimeoutSecond == 0) {
                    clearInterval(this.quizTimerInterval)
                    return
                }

                this.currentTimeoutSecond -= 1000
            }, 1000)
        },

        addSong() {
            if (this.question.spotify_track) {
                const track = this.question.spotify_track

                if (!this.question.spotify_track.only_master || this.isPlayTogether) {
                    let audio = this.audioSpotify
                    let cachePreviewUrl = track.cache_preview_url ? track.cache_preview_url : track.preview_url

                    cachePreviewUrl = cachePreviewUrl.indexOf('mp3') > -1 ? cachePreviewUrl : `${cachePreviewUrl}.mp3`

                    audio.removeEventListener('loadeddata', () => {})
                    audio.addEventListener('loadeddata', () => {
                        this.isPlayingMusic = true

                        if (this.$refs.musicPlayer && this.playerSound.questionMusic) {
                            this.$refs.musicPlayer.showPlayer()
                            this.handleMute(audio, false)
                        }
                    })

                    this.songXhrRequest = helper.ajaxBlob(
                        cachePreviewUrl,
                        res => {
                            audio.setAttribute('src', res)
                            audio.load()
                        },
                        () => {}
                    )

                    this.isSoundQuestion = true
                }
            }

            if (this.quiz.questions[this.currentQuizIndex + 1]) {
                this.preloadNextSong(this.quiz.questions[this.currentQuizIndex + 1])
            }
        },

        toggleMusic() {
            this.isPlayingMusic = !this.isPlayingMusic
            if (this.playerSound.questionMusic) {
                if (this.isPlayingMusic) {
                    this.audioSpotify.muted = false
                    this.handleMute(this.audioSpotify, false)
                } else {
                    this.handleMute(this.audioSpotify, true)
                }
            }
        },

        playRevealImage() {
            // Use css by add class animate-reveal instead, we can remove gsap function later
            // gsap.set('.bg-main', { filter: "blur(10px)" })
            // gsap.to('.bg-main', { filter: "blur(0)", duration: 10, ease: 'none' })
        },

        stopSong() {
            if (this.audioSpotify) {
                this.handleMute(this.audioSpotify, true)
            }
        },

        checkTypeOfQuestion() {
            // Support old music question
            if (
                !this.question.question_type &&
                this.question.spotify_track &&
                this.question.spotify_track.preview_url
            ) {
                this.addSong()
            }

            switch (this.question.question_type) {
                case 'music':
                    this.addSong()
                    break

                case 'reveal_image':
                    this.playRevealImage()
                    break

                case 'scale_image':
                    this.playScaleImage()
                    break
            }
        },

        playScaleImage() {
            gsap.set('.bg-main', { backgroundSize: '500% 500%' })
            gsap.to('.bg-main', { backgroundSize: '100% 100%', duration: 10, ease: 'none' })
        },

        setPuzzleImage() {
            const layoutElem = document.getElementsByClassName('layout')[0]
            let horizontalPieces = Math.floor(Math.sqrt(this.question.puzzle_block))
            let verticalPieces = Math.ceil(Math.sqrt(this.question.puzzle_block))
            let pieces = {
                horizontalPieces,
                verticalPieces
            }

            if (!this.question.puzzle_block) {
                pieces = {
                    horizontalPieces: 2,
                    verticalPieces: 2
                }
            }

            if (!this.$refs['puzzle-container']) {
                return
            }

            this.puzzleSize = 500

            if (layoutElem.getBoundingClientRect().width < 1366) {
                this.puzzleSize =
                    layoutElem.getBoundingClientRect().width > 400 ? 400 : layoutElem.getBoundingClientRect().width
            }

            this.$refs['puzzle-container'].style.width = `calc(${this.puzzleSize}px - 2rem)`
            this.$refs['puzzle-container'].style.height = `calc(${this.puzzleSize}px - 2rem)`

            new Puzzle(
                {
                    container: this.$refs['puzzle-container'],
                    image: this.question.image,
                    onComplete: () => {
                        this.$refs.quizHeader.stopProgressBar()
                        this.puzzleResultAnimation(true)
                        clearTimeout(this.quizTimeOut)
                        setTimeout(() => {
                            this.handleClickSelectAnswer(0)
                        }, appConfig.delayPuzzleDone * 1000)
                    }
                },
                pieces
            )
        },

        setFormatText: helper.setFormatText,

        puzzleResultAnimation(answer) {
            const bgIcon = document.querySelector('.circle-bg')

            if (answer) {
                const correctIcon = document.querySelector('#check-icon')
                const randomIcon = this.correctIconList[Math.floor(Math.random() * this.correctIconList.length)].icon
                correctIcon.classList.add(randomIcon)

                if (randomIcon.bg) {
                    bgIcon.classList.remove('hide')
                }

                correctIcon.classList.remove('hide')
            } else {
                bgIcon.classList.add('wrong')
                bgIcon.classList.remove('hide')
                document.querySelector('#x-icon').classList.remove('hide')
            }

            const resultTimeline = gsap.timeline({ delay: 0, repeat: 0 })

            gsap.set('.puzzle-backdrop', { opacity: 0 })
            gsap.set('.circle-box', { opacity: 0, y: '18.7rem' })

            resultTimeline
                .to('.puzzle-backdrop', { duration: 0.5, opacity: 1, display: 'block' }, 0)
                .to('.circle-box', { duration: 0.5, opacity: 0.75, y: 0, ease: 'back.out(1)' }, 0.3)
                .to('.circle-box', { duration: 0.5, opacity: 0, y: '-18.7rem' }, 1.3)
                .to('.puzzle-backdrop', { duration: 0.5, opacity: 0 }, 1.3)
        }
    },

    computed: {
        ...mapGetters({
            question: 'player/getCurrentQuiz',
            questionCount: 'player/getQuestionCount',
            audioSpotify: 'getSpotifyAudio',
            delayAnswer: 'player/getDelayAnswer',
            delayQuestion: 'player/getDelayQuestion',
            timeLimit: 'player/getTimeLimit',
            playerSound: 'player/getPlayerSound',
            progressBarStatus: 'player/getProgressBarStatus',
            joinAsPlayer: 'player/joinAsPlayer'
        }),

        ...mapState({
            quiz: state => state.player.quiz,
            title: state => state.player.quiz.title,
            name: state => state.player.name,
            code: state => state.player.quiz.code,
            type: state => state.player.quiz.type,
            currentQuizIndex: state => state.player.currentQuizIndex,
            isMasterPlayer: state => state.player.isMasterPlayer,
            isPlayTogether: state => state.player.isPlayTogether,
            isMuted: state => state.isMuted
        }),

        isMultiple() {
            return this.question.answers_required === 'multiple' && this.type !== 'poll'
        }
    },

    beforeRouteLeave(to, from, next) {
        let self = this

        this.stopSong()
        window.onbeforeunload = function () {}

        if (this.songXhrRequest) {
            this.songXhrRequest.abort()
        }

        if (
            (to.name === 'result' && (self.isMasterPressedNext || self.isSelected)) ||
            to.name === 'summary' ||
            (to.name === 'redirect-quiz' && self.isMasterPressedNext)
        ) {
            next()
        } else {
            next(false)
            popup.confirm(
                this.$t('playlive_alert_leave'),
                function () {
                    this.$store.dispatch('player/emitUserEndGameToSocket', {
                        room: self.code,
                        name: self.name,
                        socket: self.$socket
                    })

                    window.location.href = '/join'
                    // next()
                },
                function () {
                    window.onbeforeunload = function () {
                        return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.border-red-light {
    border-color: var(--icon-color);
}

.logo {
    @media (min-width: 767px) {
        width: 12rem;
    }
}

.show-answer {
    opacity: 1 !important;
    pointer-events: all;
}

.layout {
    height: calc(100vh - 2rem);
    height: calc((var(--vh, 1vh) * 100) - 2rem);
    margin-top: -1rem;
    margin-right: -1rem;
    margin-left: -1rem;

    @media (max-width: 320px) {
        height: calc(100vh);
        height: calc((var(--vh, 1vh) * 100));
    }

    &.layout-scale {
        padding: 0;
    }

    .content {
        padding-left: 1rem;
        padding-right: 1rem;

        @media screen and (max-width: 767px) {
            overflow: hidden;
            padding-left: 0;
            padding-right: 0;
        }

        @media screen and (min-width: 515px) and (max-width: 740px) {
            padding: 0;
        }

        #question-title {
            word-break: break-word;
        }

        .video-box {
            width: 450px;
            aspect-ratio: 16 / 9;
            overflow: hidden;

            @media screen and (max-width: 500px) {
                min-width: unset;
                max-width: unset;
                width: 100%;
                height: auto;
                border: none;
                border-radius: 0;
            }
        }

        .answer-box {
            padding: 0 1rem;
        }

        .puzzle-backdrop {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);
            z-index: 2;
            display: none;
            overflow: hidden;

            .circle-box {
                position: absolute;
                top: calc(50% - (8rem / 2));
                left: calc(50% - (8rem / 2));
                width: 8rem;
                height: 8rem;

                .circle-bg {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 5.4rem;
                    height: 5.4rem;
                    background-color: rgba(0, 0, 0, 0.3);

                    &.wrong {
                        background-color: #fff;
                    }
                }

                i {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 8rem;
                    text-shadow: 0 0 4px #000;

                    &#check-icon {
                        color: #fff;
                    }

                    &.fa-times-circle {
                        color: red;
                    }
                }

                .hide {
                    opacity: 0;
                }
            }
        }
    }
}

@media screen and (min-width: 768px) and (max-width: 1920px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
}

@media screen and (max-width: 767px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
}

.bg-main-container::before {
    border: none;
}

.bg-main {
    &.animate-reveal {
        animation: reveal 10s none;
    }
}

@keyframes reveal {
    0% {
        filter: blur(10px);
    }

    100% {
        filter: blur(0);
    }
}

@media screen and (max-width: 500px) {
    .bg-main-container {
        &.has-video {
            width: 100%;
        }
    }
}

@media screen and (min-width: 741px) {
    .content-container {
        width: 720px;
    }
}

@media screen and (min-width: 741px) {
    .count-box-size {
        width: 520px;
    }
}

@media screen and (min-width: 320px) and (max-width: 420px) {
    #question-title {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
}
</style>
